import {
    Alert,
    Box,
    Button,
    Divider,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import {useState} from "react";
import {ViewConstructorResultDto} from "../../api/psc";
import {DialogContainer, DialogHeader} from "../../components/exports";

export default function SelectConstructorPhoneNumberDialog(props: {
    constructorViewInfo: ViewConstructorResultDto;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const openWhatsApp = (mobileNumber: string) => {
        const mobileNumberWithout0 = mobileNumber.substring(1);
        window.open(`https://wa.me/98${mobileNumberWithout0}`);
    };

    const openWhatsAppWeb = (mobileNumber: string) => {
        const mobileNumberWithout0 = mobileNumber.substring(1);
        window.open(
            `https://web.whatsapp.com/send?phone=98${mobileNumberWithout0}`
        );
    };

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return <Stack direction='column' gap={2}>
        <Alert severity="warning">
            به قوانین واتس اپ در زمینه مسدود شدن شماره توجه داشته باشید
        </Alert>

        <Box >
            <Stack spacing={1} divider={<Divider/>}>
                {props.constructorViewInfo.constructor?.mobileNumbers.map(
                    (c) => {
                        return (
                            <Stack
                                key={c}
                                direction="row"
                                alignItems="center"
                                gap={1}
                            >
                                <Typography sx={{flexGrow: 1}}>
                                    {c}
                                </Typography>

                                <Button
                                    onClick={openMenu}
                                    variant="contained"
                                    color="secondary"
                                >
                                    ارسال پیام
                                </Button>

                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={closeMenu}
                                >
                                    <MenuItem
                                        onClick={() => openWhatsApp(c)}
                                    >
                                        ارسال در نسخه دسکتاپ
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => openWhatsAppWeb(c)}
                                    >
                                        ارسال در نسخه وب
                                    </MenuItem>
                                </Menu>
                            </Stack>
                        );
                    }
                )}
            </Stack>
        </Box>
    </Stack>
}
